import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui';
import router from '../router/index'
import store from '../store'
// const METHOD = {
//     // URL: "	http://127.0.0.1:4523/mock/374473"
// URL:"https://www.weisou.online"
// }

// 构建axios实例
const instance = axios.create({
    // baseURL: "/api",   //开发
    baseURL: "https://www.otobtb.com/Bicycle/", //上线
    // baseURL: 'http://192.168.0.110:8083/bicycle/',
    // baseURL: 'http://192.168.1.108:8083/bicycle/',
    // baseURL: 'https://www.weisou.online/bicycle/',
    // baseURL: 'https://www.weisou.online/bicycle/',
    // baseURL: 'https://www.otobtb.com/Bicycle/',
    headers: {
        'content-type': 'application/x-www-form-urlencoded'
    },
    // timeout: 5000  // 设置请求超时连接时间
})

axios.defaults.withCredentials = true
    // 请求拦截
instance.interceptors.request.use(
    (config) => {
        // 指定请求令牌
        // if (localStorage.getItem('token')) {
        //     config.headers["token"] = localStorage.getItem('token');
        // }
        // console.log(config)
        // // 自定义令牌的字段名为X-Token，根据咱们后台再做修改
        return config;
    },
    (error) => {
        // 请求错误的统一处理
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// // 响应拦截器
instance.interceptors.response.use(
    /**
     * 通过判断状态码统一处理响应，根据情况修改
     * 同时也可以通过HTTP状态码判断请求结果
     */
    (response) => {
        const res = response.data;
        //异地登录
        if (res.code == 402) {
            router.push("/");
            Message.error({
                message: res.msg || "Error",
                duration: 2 * 1000,
            });
            return Promise.reject(new Error(res));
        }
        // 如果状态码不是200则认为有错误
        if (res.code != 200) {
            Message.error({
                message: res.msg || "Error",
                duration: 2 * 1000,
            });
            return Promise.reject(new Error(res));
        } else {

            if (store.state.lang == 'zh') {

                // if (!res.success) {
                    if (res.msg.indexOf("|") > 0) {
                        res.msg =  res.msg = res.msg.split("|")[0]
                    }
                // } 

            } else {
                // if (!res.success) {
                    if (res.msg.indexOf("|") > 0) {
                        res.msg =  res.msg = res.msg.split("|")[1]
                    }
                // } 


            }
            return res;
        }
    },
    error => {
        Message({
            message: error.response.data.msg,
            type: "error",
            duration: 20 * 1000,
        });
        if (error.response.data.code == 402) {
            router.push("/");
        }
        return Promise.reject(error);
    },
);


// * 网络请求
// * @param method 方法
// * @param url 接口地址
// * @param params 参数
// * @param showError 是否展示错误信息
// * @returns {Promise<any>}
async function getHttp(url, params, showError) {
    if (showError || showError == undefined) { // 是否展示错误信息
        showError = true;
    } else {
        showError = false;
    }
    console.log('params', params);
    if (!params) {
        params = {
            language: store.state.lang == 'zh' ? 1 : 2
        }
    } else {
        params.language = store.state.lang == 'zh' ? 1 : 2
    }

    return new Promise((resolve, reject) => {
        instance({
            url: url,
            method: 'get',
            params: params
        }).then((res) => {
            // console.log(res)
            if (res.code == 200) { // 200 是请求成功
                resolve(res);
            } else { // 其他情况返回错误信息，根据需要处理
                reject(res);
                if (showError) {
                    Message.error(res.msg);
                }
            }
        }).catch((error) => {
            // Message.error(error.data.msg);
            reject(error);
            // if (showError) {
            //     Message.error('请求失败，请稍后再试');
            // }
        })
    })
}

async function postHttp(url, params, showError) {
    if (showError || showError == undefined) { // 是否展示错误信息
        showError = true;
    } else {
        showError = false;
    }
    params.language = store.state.lang == 'zh' ? 1 : 2;
    return new Promise((resolve, reject) => {
        instance({
            url: url,
            method: 'post',
            data: qs.stringify(params)
        }).then((res) => {
            // console.log(res.code)
            if (res.code == 200) { // 200 是请求成功
                // console.log('picpipcpic')
                resolve(res);
            } else { // 其他情况返回错误信息，根据需要处理
                reject(res);
                if (showError) {
                    Message.error(res.data.msg);
                }
            }
        }).catch((error) => {
            // .data.msg
            // Message.error(error);
            reject(error);
            // if (showError) {
            //     Message.error('请求失败，请稍后再试');
            // }
        })
    })
}

function downloadPost(config) {
    return new Promise((resolve, reject) => {
        instance({
            url: config.url, // 请求地址
            method: 'post',
            data: config.data, // 参数
            responseType: 'blob' // 表明返回服务器返回的数据类型
        }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err);
        });
    });
}



function install(Vue) {
    Vue.prototype.$download = downloadPost
    Vue.prototype.$getHttp = getHttp;
    Vue.prototype.$postHttp = postHttp;

    // Vue.prototype.$upload = 'http://192.168.0.104:8081/Bicycle/ht/attach/upload'    
    // Vue.prototype.$imgUrl = "http://192.168.0.104:8081/Bicycle/upload";

    // Vue.prototype.$url = "http://192.168.0.102:8081/Bicycle//";
    // Vue.prototype.$dataUrl = "http://192.168.0.102:8081/Bicycle//pc/teaData/downloadData?path="
    // Vue.prototype.$upload = "https://www.weisou.online/bicycle/ht/attach/upload" //开发

    // Vue.prototype.$imgUrl = "https://www.weisou.online/bicycle/upload/";

    Vue.prototype.$upload = 'https://www.otobtb.com/Bicycle/ht/attach/upload',
        Vue.prototype.$imgUrl = "https://www.otobtb.com/Bicycle/upload/";
}
export default install